import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const wiki = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default wiki;



// WEBPACK FOOTER //
// ./src/store/wiki/index.js